import './assets/scss/main.scss'
import App from './js/components/App'


const app = new App({ target: document.getElementById('app')});
app.init()